import { FormControlLabel, Grid, Paper, Stack, Switch } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { SnackbarAlertWidget } from '../../../../widgets';
import SelectFieldNivelesAcademicosComponent from '../../../entidad/ent_niveles_academicos/components/SelectFieldEntNivelesAcademicos';
import SelectFieldDocentesComponent from '../../docentes/components/SelectFieldDocentes';
import { allMateriasAction } from '../../materias/MateriasAction';
import SelectFieldMateriasComponent from '../../materias/components/SelectFieldMaterias';
import { allSeccionesAction } from '../../secciones/SeccionesAction';
import SelectFieldSeccionesComponent from '../../secciones/components/SelectFieldSecciones';
import { allHorariosAction } from '../HorariosAction';
import {
  ALL_HORARIOS,
  PARAMS_HORARIOS,
  SETTINGS_HORARIOS,
} from '../HorariosReducer';

const FiltrosHorariosComponent = () => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const materiasStore = Redux.useSelector((state) => state.materias);
  const seccionesStore = Redux.useSelector((state) => state.secciones);
  const entHorariosClasesStore = Redux.useSelector(
    (state) => state.entHorariosClases,
  );
  const horariosStore = Redux.useSelector((state) => state.horarios);
  const docentesStore = Redux.useSelector((state) => state.docentes);

  const [materias, setMaterias] = React.useState('');
  const [secciones, setSecciones] = React.useState('');

  React.useEffect(() => {
    async function fetchData() {
      if (materiasStore.all.length === 0) {
        await allMateriasAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
      }

      if (seccionesStore.all.length === 0) {
        await allSeccionesAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
      }
      const payload = {
        idEntidad: entidadesStore.activo.id,
        idPeriodoAcademico: entidadesStore.ajustes.periodoAcademico.id,
        idHorarioClase: entHorariosClasesStore.activo?.id,
      };

      if (loginStore.isAdminTeacher) {
        payload['idDocente'] = docentesStore.activo.id;
      }

      dispatch({ type: PARAMS_HORARIOS, payload });
    }

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    async function fetchData() {
      if (horariosStore.params.idDocente) {
        setMaterias([]);
        setSecciones([]);

        const docente = docentesStore.all.find(
          (docente) => docente.id === horariosStore.params.idDocente,
        );

        if (!loginStore.isAdminTeacher && docente.materias.length > 0) {
          docente.materias.forEach((el) => {
            setMaterias((prev) => [...prev, el.materia]);
          });
        } else {
          materiasStore.all.forEach((el) => {
            setMaterias((prev) => [...prev, el]);
          });
        }
        if (!loginStore.isAdminTeacher && docente.secciones.length > 0) {
          docente.secciones.forEach((el) => {
            setSecciones((prev) => [...prev, el.seccion]);
          });
        } else {
          seccionesStore.all.forEach((el) => {
            setSecciones((prev) => [...prev, el]);
          });
        }

        dispatch({
          type: PARAMS_HORARIOS,
          payload: {
            ...horariosStore.params,
            idSeccion: null,
            idMateria: null,
          },
        });
      }
    }

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [horariosStore.params.idDocente]);

  const getData = async (payload) => {
    if (
      !payload.idDocente &&
      !payload.idMateria &&
      !payload.idSeccion &&
      !payload.idNivelAcademico
    ) {
      return;
    }

    if (!payload) {
      dispatch({
        type: ALL_HORARIOS,
        payload: { data: [] },
      });
    }

    dispatch({ type: PARAMS_HORARIOS, payload });
    await allHorariosAction({ dispatch, horariosStore }, payload);
  };

  // const seccionParam =
  //   horariosStore.params.idSeccion === 'all'
  //     ? null
  //     : horariosStore.params.idSeccion;

  return (
    <>
      <Paper elevation={2} sx={{ my: 1, p: 1 }}>
        <Grid container spacing={1}>
          {!loginStore.isAdminTeacher && (
            <Grid item xs={12} md={3}>
              <SelectFieldDocentesComponent
                id="filtro-docentes"
                value={horariosStore.params.idDocente || ''}
                onChange={(idDocente) => {
                  // if (
                  //   !idDocente &&
                  //   (horariosStore.params.idSeccion ||
                  //     horariosStore.params.idNivelAcademico ||
                  //     horariosStore.params.idMateria)
                  // ) {
                  //   return getData({
                  //     ...horariosStore.params,
                  //     idDocente: null,
                  //   });
                  // }

                  getData({
                    ...horariosStore.params,
                    idDocente,
                  });
                }}
              />
            </Grid>
          )}
          <Grid item xs={12} md={3}>
            <SelectFieldMateriasComponent
              id="filtroMaterias"
              value={horariosStore.params.idMateria || ''}
              data={
                horariosStore.params.idDocente && !loginStore.isAdminTeacher
                  ? materias
                  : null
              }
              onChange={(idMateria) => {
                // if (
                //   !idMateria &&
                //   (horariosStore.params.idSeccion ||
                //     horariosStore.params.idNivelAcademico)
                // ) {
                //   return getData({
                //     ...horariosStore.params,
                //     idMateria: null,
                //   });
                // }

                getData({
                  ...horariosStore.params,
                  // idSeccion: seccionParam,
                  idMateria,
                });
              }}
            />
          </Grid>
          {!horariosStore.params.idNivelAcademico && (
            <Grid item xs={12} md={3}>
              <SelectFieldSeccionesComponent
                id="filtroSecciones"
                value={horariosStore.params.idSeccion || ''}
                data={horariosStore.params.idDocente ? secciones : null}
                onChange={(idSeccion) => {
                  // if (idSeccion) {
                  //   const payload = {
                  //     ...horariosStore.params,
                  //     idSeccion,
                  //     idDocente: null,
                  //     idMateria: null,
                  //     idNivelAcademico: null,
                  //   };
                  //   dispatch({ type: PARAMS_HORARIOS, payload });
                  //   allHorariosAction(
                  //     { dispatch, horariosStore },
                  //     { ...payload, idSeccion: null },
                  //     true,
                  //   );
                  //   return;
                  // }

                  getData({
                    ...horariosStore.params,
                    idSeccion,
                  });
                }}
              />
            </Grid>
          )}

          <Grid item xs={12} md={horariosStore.params.idNivelAcademico ? 6 : 3}>
            <Stack direction="row">
              <SelectFieldNivelesAcademicosComponent
                id="filtroNiveles"
                value={horariosStore.params.idNivelAcademico || ''}
                onChange={(idNivelAcademico) => {
                  // if (!idNivelAcademico) {
                  //   return getData({
                  //   ...horariosStore.params,
                  //   idNivelAcademico,
                  //   idSeccion: null,
                  //   })
                  // }
                  getData({
                    ...horariosStore.params,
                    idSeccion: null,
                    idNivelAcademico,
                  });
                }}
              />
              {horariosStore.params.idNivelAcademico && (
                <FormControlLabel
                  sx={{ ml: 2, width: '400px' }}
                  control={
                    <Switch
                      checked={horariosStore.settings.isCalendarioSeparados}
                      onChange={(event) => {
                        dispatch({
                          type: SETTINGS_HORARIOS,
                          payload: {
                            ...horariosStore.settings,
                            isCalendarioSeparados: event.target.checked,
                          },
                        });
                      }}
                    />
                  }
                  label="Separar por secciones"
                />
              )}
            </Stack>
          </Grid>
        </Grid>
      </Paper>
      <SnackbarAlertWidget
        message={
          horariosStore.settings.isEditCalendar
            ? 'Modo edición activado'
            : horariosStore.settings.isCut
            ? 'Modo recorte activado'
            : null
        }
        bottomCenter
      />
    </>
  );
};

export default FiltrosHorariosComponent;
